export default {

	// Anvil - defaults
	defaultAction: {
		controller: 'auth',
		action: 'control_user_login'
	},
	defaultActionParams: { },
	defaultTemplate: 'ui/layout',

	// Anvil - localization
	localization: true,		// only load language files if localization is true
	defaultLanguage: 'hu',
	momentLocale: 'hu',
	numeralLocale: 'hu',
	numeralLocales: {
		'hu': {
			delimiters: {
				thousands: ' ',
				decimal: ','
			},
			abbreviations: {
				thousand: 'E',  // ezer
				million: 'M',   // millió
				billion: 'Mrd', // milliárd
				trillion: 'T'   // trillió
			},
			ordinal: function (number) {
				return '.';
			},
			currency: {
				symbol: ' Ft'
			}
		}
	}
}
